import React from 'react';
import {Container, SubHeading, Heading,ButtonLink} from './styles/errorPage';

export default function ErrorPage({children, ...restProps}) {
  return (<Container {...restProps}> {children} </Container>)
}

ErrorPage.SubHeading = function ErrorPageSubHeading({children, ...restProps}){
  return <SubHeading {...restProps}>{children}</SubHeading>
}

ErrorPage.Heading = function ErrorPageHeading({children, ...restProps}){
  return <Heading {...restProps}>{children}</Heading>
}

ErrorPage.ButtonLink = function ErrorPageButtonLink({children, ...restProps}){
    return <ButtonLink {...restProps}>{children} </ButtonLink>
}